import { registerPlugin } from '@capacitor/core';
import { JustWeiApkUpdaterWeb } from './web';
const JustWeiApkUpdater = registerPlugin('JustWeiApkUpdater', {
    web: () => new JustWeiApkUpdaterWeb(),
});
export * from './definitions';
export { JustWeiApkUpdater };
//# sourceMappingURL=index.js.map